/*
 *
 * Workspace constants
 *
 */

export const SET_PLUGIN_LIST = 'app/Workspace/Plugins/SET_PLUGIN_LIST';
export const SET_PLUGIN_VERSION_LIST = 'app/Workspace/Plugins/SET_PLUGIN_VERSION_LIST';
export const PLUGIN_CREATE_REQUEST = 'app/Workspace/Plugins/PLUGIN_CREATE_REQUEST';
export const PLUGIN_CREATE_SUCCESS = 'app/Workspace/Plugins/PLUGIN_CREATE_SUCCESS';
export const PLUGIN_CREATE_ERROR = 'app/Workspace/Plugins/PLUGIN_CREATE_ERROR';
export const SET_PLUGIN_DETAILS = 'app/Workspace/Plugins/SET_PLUGIN_DETAILS';
export const SET_PLUGIN_COLLABORATOR_SUMMARY = 'app/Workspace/Plugins/SET_PLUGIN_COLLABORATOR_SUMMARY';
